import React from "react";
import servicesData from "../../../assets/data/servicesData.json";
import productsData from "../../../assets/data/productsData.json";

function FooterOne() {
  const today = new Date();

  return (
    <footer>
      <div
        className="footer-area footer-bg"
        style={{
          backgroundImage: `url(${require("../../../assets/img/bg/footer_bg.jpg")})`,
        }}
      >
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-4 col-md-7">
                <div className="footer-widget">
                  <h2 className="fw-title">O naší společnosti</h2>
                  <div className="footer-content">
                    <p>
                      Specializujeme se na dodávky hutních materiálů, zejména z
                      nerezové a ušlechtilé oceli, s přímým přístupem k výrobcům
                      a síti skladů. Nabízíme speciální jakosti a rozměry s
                      kompletním servisem, včetně dopravy a celních služeb.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h2 className="fw-title">Náš sortiment</h2>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      {productsData.map((product, index) => (
                        <li key={index}>
                          <a href={`/products/${product.detailLink}`}>
                            <i className="fas fa-angle-double-right"></i>
                            {product.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h2 className="fw-title">Naše služby</h2>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      {servicesData.map((service, index) => (
                        <li key={index}>
                          <a href={`/services/${service.links}`}>
                            <i className="fas fa-angle-double-right"></i>
                            {service.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-logo-area">
              <div className="row align-items-center">
                <div className="col-xl-3 col-lg-3 col-md-12">
                  <div className="logo">
                    <a href="/">
                      <img
                        src={require(`../../../assets/img/logo/logo.png`)}
                        alt=""
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <div className="footer-contact">
                    <div className="icon">
                      <i className="fas fa-phone-alt"></i>
                    </div>
                    <div className="content">
                      <span>Tel. číslo</span>
                      <a href="tel:0123456789">+(420) 266 610 930</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="copyright-text">
                  <p>© {today.getFullYear()} MARC spol s r.o.</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="footer-bottom-menu">
                  <ul className="list-wrap"></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterOne;
